import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
  alpha,
  Paper,
  IconButton,
  DialogActions,
  Box
} from "@mui/material";
import { FormFactor } from "../../types/enums/FormFactor";
import { useFormFactor } from "../../hooks/useFormFactor";
import CloseIcon from '@mui/icons-material/Close';
import PreviewIcon from '@mui/icons-material/Preview';

export const TemplatePreviewModal = ({
  newText,
  open,
  onTemplateSaved,
  onPreviewClosed,
}: {
  newText: string;
  open: boolean;
  onTemplateSaved: (newText: string) => void;
  onPreviewClosed: () => void;
}) => {
  const formFactor = useFormFactor();
  const theme = useTheme();
  
  return (
    <Dialog
      open={open}
      onClose={onPreviewClosed}
      fullWidth={true}
      maxWidth="md"
      fullScreen={formFactor < FormFactor.Tablet}
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: theme.palette.mode === 'dark' ? '#1e1e1e' : undefined
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          backgroundColor: theme.palette.primary.main, 
          color: theme.palette.primary.contrastText,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PreviewIcon sx={{ mr: 1 }} />
          <Typography variant="h6" component="div">
            Template Preview
          </Typography>
        </Box>
        <IconButton 
          edge="end" 
          color="inherit" 
          onClick={onPreviewClosed} 
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 3, bgcolor: theme.palette.mode === 'dark' ? '#1e1e1e' : undefined }}>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 3, 
            mb: 3, 
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : alpha(theme.palette.background.paper, 0.7),
            borderRadius: 2,
            whiteSpace: 'pre-wrap'
          }}
        >
          <Typography>{newText}</Typography>
        </Paper>
      </DialogContent>
      
      <DialogActions sx={{ 
        px: 3, 
        py: 2,
        backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : alpha(theme.palette.background.paper, 0.5),
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`
      }}>
        <Button 
          onClick={onPreviewClosed}
          variant="outlined"
          sx={{ 
            minWidth: '100px',
            borderRadius: 1.5
          }}
        >
          Close
        </Button>
        <Button
          onClick={() => {
            onTemplateSaved(newText);
            onPreviewClosed();
          }}
          variant="contained"
          color="primary"
          sx={{ 
            minWidth: '100px',
            borderRadius: 1.5,
            ml: 2
          }}
        >
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
};
